import { RxDashboard } from "react-icons/rx";
import { BsBoxSeam, BsClipboardData } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import { MdOutlineCampaign, MdOutlineMoodBad } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { FiUser } from "react-icons/fi";
import { HiOutlineBuildingOffice2, HiOutlineChatBubbleOvalLeftEllipsis } from "react-icons/hi2";
import { ImLab } from "react-icons/im";
import { IoNotificationsOutline, IoSearchOutline } from "react-icons/io5";
import { TbUsers } from "react-icons/tb"
import { FaTasks } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";

export const links = [
    // {
    //     title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
    //     Icon: RxDashboard,
    //     links: [
    //         {
    //             title: <FormattedMessage id="Tickets" defaultMessage={"Tickets"} />,
    //             Icon: FiUser,
    //             to: "/tickets",
    //         }
    //     ]
    // },
    {
        title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
        Icon: RxDashboard,
        to: "/",
    },
    // {
    //     title: <FormattedMessage id="discovery" defaultMessage={"Discovery"} />,
    //     Icon: IoSearchOutline,
    //     to: "/discovery",
    // },
    // {
    //     title: <FormattedMessage id="campaign" defaultMessage={"Campaign"} />,
    //     Icon: MdOutlineCampaign,
    //     to: "/campaign",
    // },
    {
        title: <FormattedMessage id="deliverables_title" defaultMessage={"Requested Content"} />,
        Icon: "video",
        IconType: "featherIcon",
        to: "/deliverables",
    }, {
        title: <FormattedMessage id="requests_title" defaultMessage={"New Collaboration Opportunities"} />,
        Icon: MdOutlinePendingActions,
        to: "/requests",
    },
    // {
    //     title: <FormattedMessage id="chats" defaultMessage={"Chats"} />,
    //     Icon: HiOutlineChatBubbleOvalLeftEllipsis,
    //     to: "/chats",
    // },
    // {
    //     title: <FormattedMessage id="notifications" defaultMessage={"Notifications"} />,
    //     Icon: IoNotificationsOutline,
    //     to: "/notifications",
    // },
    {
        title: <FormattedMessage id="influencer_profile" defaultMessage={"Your Professional Profile"} />,
        Icon: FiUser,
        to: "/profile",
    },

]